angular.module('appSettingInviteCoupon', [
  'ngRoute',
  'ngResource',
  'core',
  'core.auth',
  'core.env',
  'pascalprecht.translate',
]);



// WEBPACK FOOTER //
// ./src/app/app-setting/invite-coupon/invite-coupon.module.js